import { ApplicationRef, Component, ComponentFactoryResolver, Injector, Input, OnInit } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { PopupComponent } from 'src/app/components/network-visibility/popup/popup.component';
import { GenericService } from 'src/app/services/generic.service';
declare const L: any;
import 'leaflet-draw';
import { LatLng } from 'leaflet';
import { get } from 'http';
import { forkJoin } from 'rxjs';
import { IDropdownSettings } from 'ng-multiselect-dropdown';
// import 'leaflet-polylinedecorator';


@Component({
  selector: 'app-locate-device',
  templateUrl: './locate-device.component.html',
  styleUrls: ['./locate-device.component.css']
})

export class LocateDeviceComponent implements OnInit {

  private map!: L.Map;
  private centroid: L.LatLngExpression = [17.4051564, 78.4927618];

  form: any | FormGroup
  marker2: any
  cid: any
  layerInfoLatLng: any = []
  objectInfoList: any = []
  assetStatusList: any = []
  objectInfoListFilter: any = []
  uomData: any = []
  objectTemplateList: any = []
  singleObjectTemplateData: any = []

  proofFile: any = ""
  proofFilePath: any = ""
  proofFileType: any = ""

  singleObjectInfoData: any = []
  layerslist: any = []
  singleLayerData: any = []
  defaultZoom: any = 14
  defaultCenter: any = [17.4065, 78.4772]
  latestLoc: any = []
  lat: any;
  lng: any
  multiLatLng: any = false
  area: any = []
  layerType: any = ""
  geojsonData: any = {
    "type": "FeatureCollection",
    "features": []
  }
  deleteId: any = ""

  objectTemplateId = ""
  objectInfoId: any
  originalCost: any = ""
  currentCost: any = ""
  branch: any = ""
  branchId: any = ""
  department: any = ""
  make: any = ""
  model: any = ""
  location: any = ""
  objectCondition: any = ""
  assetStatus: any = ""
  givenName: any = ""
  serialNumber: any = ""
  locationList: any = []
  branchList: any = []
  maintenanceList: any = []
  objectColorCode: any = ""
  isObjectColorCode: any = false
  objectQty: any = ""
  objectUOM: any = ""
  availableQty: any = ""

  maintenanceType = [
    {
      key: "Preventive Maintenance (PM) Schedule",
      value: "PreventiveMaintenanceSchedule"
    },
    {
      key: "Corrective Maintenance Schedule",
      value: "CorrectiveMaintenanceSchedule"
    },
    {
      key: "Predictive Maintenance Schedule",
      value: "PredictiveMaintenanceSchedule"
    },
    {
      key: "Condition-Based Maintenance (CBM)",
      value: "ConditionBasedMaintenance"
    }
  ]

  frequencyType = [
    {
      key: "Daily: Operational checks (temperature, pressure, noise, etc.)",
      value: "Daily"
    },
    {
      key: "Weekly: Lubrication, filter checks, fluid levels",
      value: "Weekly"
    },
    {
      key: "Monthly: In-depth inspections, cleaning, software updates",
      value: "Monthly"
    },
    {
      key: "Quarterly: Component replacements (belts, seals), diagnostics",
      value: "Quarterly"
    },
    {
      key: "Annually: Major overhauls, part replacements, certifications",
      value: "Annually"
    }
  ]

  showFilter: any = false
  detailShow: any = false
  objectTypeData: any = [];
  objectGroupData: any = [];
  usersList: any = [];
  isLoading: any = false;
  maintenanceScheduleList: any = [];
  file: any;
  imagesList: any = [];
  imagesWithDetails: any = [];

  largeImage: any = "";
  iconFile: any;
  icon: any = '';
  todayDate: any;


  minEndDate: any;
  editPerformanceMatrix: any = false
  performanceMatrixList: any = [];
  nameValue: any;
  performanceMatrix: any;
  acquisitionDate: any = "";
  salvageValue: any;
  depreciationMethod: any;
  assetLifeNumber: any;
  asset_Category: any = "";
  objectCategoryList: any = [];
  assetDepreciationDataList: any = [];
  departmentInfoList: any = [];

  // putToUseDate: any = "";
  isOriginalCost: any = false;
  isAsset_Category: any = false;
  // isPutToUseDate: any = false;
  isSalvageValue: any = false;
  isAssetLifeNumber: any = false;

  assetConditions = [
    { value: 'Good', label: 'Good' },
    { value: 'UnderRepair', label: 'Under Repair' },
    { value: 'Scrap', label: 'Scrap' }
  ];

  tags: any = []
  isClone: any = false
  templateName: any;
  menuToggle: any = false


  repairInfoForm: any | FormGroup;
  addAsset: any | FormGroup;
  isMaintenanceSchedule: any = false
  assetMonitoring: any = false
  assetMonitoringFrequency: any = 0
  assetMonitoringTimeSpan: any = 0
  assetHealth: any = false
  connectionsList: any = []
  assetHealthList: any = []
  searchFilter: any = ""
  template: any = ""

  constructor(private fb: FormBuilder, private toastr: ToastrService, private generic_service: GenericService,
    private resolver: ComponentFactoryResolver,
    private appRef: ApplicationRef, private router: Router,
    private injector: Injector) {

    this.generic_service.menuToggle.subscribe((value) => {
      this.menuToggle = Boolean(value)
      if (this.menuToggle) {
        this.bi_fullscreen = "fullscreen-map1"
      } else {
        this.bi_fullscreen = "fullscreen-map"
      }

    });
  }



  @Input() goodCount: number = 75;
  @Input() badCount: number = 25;

  goodPercentage: number = 0;
  badPercentage: number = 0;


  parentSelectedList: any = [];
  parentDropdownSettings: IDropdownSettings = {
    singleSelection: false,
    idField: 'objectInfoId',
    textField: 'givenName',
    selectAllText: 'Select All',
    unSelectAllText: 'UnSelect All',
    itemsShowLimit: 3,
    allowSearchFilter: true
  };

  userCred: any
  locationFilterList: any = []

  ngOnInit(): void {
    const now = new Date();
    this.todayDate = now.toISOString().split('T')[0]; // Format: YYYY-MM-DD
    const total = this.goodCount + this.badCount;
    this.goodPercentage = total > 0 ? (this.goodCount / total) * 100 : 0;
    this.badPercentage = total > 0 ? (this.badCount / total) * 100 : 0;
    this.form = this.fb.group({
      layerName: [''],
      layerColor: ['#e01a1a'],
      layerLevel: ['']
    })

    this.userCred = JSON.parse(sessionStorage.getItem('userCreds')!);

    this.getAllUomMaster()
    this.getAllAssetStatus()
    this.cid = sessionStorage.getItem('cid')
    this.getAllObjectTemplate()
    this.getAllObjectInfo()
    this.getAllLocation()
    this.getAllBranch()
    this.getUsersWithoutCustomers()
    this.getAllGroupList()
    this.getAllTypeList()
    this.getAllObjectCategory()
    this.getAllAssetDepreciationMethod()
    this.getAllDepartment_info()
    this.initMap();

  }

  getUsersWithoutCustomers() {
    this.generic_service.getUsersWithoutCustomers().subscribe(
      (res: any) => {
        console.log(res);
        this.usersList = res.response;
      }
    )
  }

  getAllDepartment_info() {
    this.generic_service.getAllDepartment_info().subscribe(
      (res: any) => {
        console.log(res)
        this.departmentInfoList = res.response
      },
      (err: any) => {
        console.log(err)
      }
    )
  }

  filterDateInput(event: any): boolean {

    const key = event.key;
    const inputElement = event.target as HTMLInputElement;
    const currentValue = inputElement.value;

    // Allow control keys (navigation, editing)
    const controlKeys = [
      'Backspace', 'Delete', 'ArrowLeft', 'ArrowRight',
      'ArrowUp', 'ArrowDown', 'Tab', 'Home', 'End'
    ];
    if (controlKeys.includes(key) || key === 'Enter') {
      return true;
    }

    // Allow only digits and slashes
    if (!/[\d/]/.test(key)) {
      event.preventDefault();
      return false;
    }

    console.log(event.target.value)

    if (currentValue != null && currentValue != '' && currentValue != undefined) {
      if (currentValue.length > 9) {
        console.log(currentValue)
        console.log("ok")
        const date = new Date(currentValue);

        const year: any = date.getFullYear();
        console.log('Year:', year);

        if (year > 999) {
          console.log(typeof year)
          event.preventDefault();
          return false;
        }

      }
    }

    return true;
  }

  onItemSelect(item: any) {
    console.log(item);
  }

  onSelectAll(items: any) {
    console.log(items);
  }

  getAllAssetDepreciationMethod() {
    this.generic_service.getAllAssetDepreciationMethod().subscribe(
      (res: any) => {
        console.log(res)
        this.assetDepreciationDataList = res.response
      },
      (err: any) => {
        console.log(err)
      }
    )
  }


  objectConditionChange() {
    if (this.objectCondition == "Good") {
      this.assetStatus = "installed/deployed"
    }

    if (this.objectCondition == "UnderRepair") {
      this.assetStatus = "under repair"
    }
  }

  getAllObjectCategory() {
    this.generic_service.getAllObjectCategory().subscribe(
      (res: any) => {
        console.log(res)
        this.objectCategoryList = res.response
      },
      (err: any) => {
        console.log(err)
      }
    )
  }

  addTag() {
    this.tags.push(
      {
        tag: "",
      }
    )
  }

  removeTag(index: any) {
    this.tags.splice(index, 1)
  }


  getAllBranch() {
    this.generic_service.getBranch().subscribe(
      (response: any) => {
        this.branchList = response.response;
      }
    )
  }


  getAllLocation() {
    this.isLoading = true
    this.generic_service.getAllLocation().subscribe(
      (res: any) => {
        console.log(res)

        if (res.response != null && res.response.length != 0) {
          for (let list of res.response) {
            list.isChecked = false
          }
        }

        this.locationList = res.response

        this.locationFilterList = (this.locationList?.filter((location: any) =>
          this.userCred?.locations?.includes(location.locationId)
        )) || [];

        console.log("locationFilterList : ", this.locationFilterList)
        this.isLoading = false
      },
      (err: any) => {
        this.isLoading = false
        console.log(err)
      }
    )
  }

  clearObject() {
    this.locationCheckList = [];
    this.objectInfoList = [];
    this.singleObjectInfoData = []
    this.showFilter = false;
    this.detailShow = false;
    this.template = ""

    if (this.map) {
      this.map.eachLayer((layer: any) => {
        // Remove all layers except the tile layer (usually)
        if (!layer._url) { // tile layer has _url property
          this.map.removeLayer(layer);
        }
      });
    }

    for (let list of this.locationList) {
      list.isChecked = false
    }

    for (let list of this.locationFilterList) {
      list.isChecked = false
    }
    this.closeDetailView()
  }

  locationCheckList: any = [];

  locationCheck(event: any, list: any) {

    this.singleObjectInfoData = []
    this.showFilter = false;
    this.detailShow = false;
    console.log(list)
    console.log(event)
    if (!list.isChecked) {
      list.isChecked = true;
      this.locationCheckList.push(list);
    } else {
      // Find index of unchecked item
      const index = this.locationCheckList.findIndex(
        (loc: any) => loc.locationId === list.locationId
      );

      if (index !== -1) {
        this.locationCheckList.splice(index, 1);
      }

      // Set unchecked flag here
      list.isChecked = false;
    }

    this.objectInfoList = [];

    if (this.locationCheckList.length === 0) {
      this.initMap(); // Reset or clear map if needed
      return; // early exit to avoid calling forkJoin on empty array
    }

    // Create array of observables
    const requests = this.locationCheckList.map((loc: any) => {
      if (this.template != "") {
        // return this.generic_service.getObjectInfoByTemplateNameAndLocation(this.template,loc.zone)

        return forkJoin({
          objectInfo: this.generic_service.getObjectInfoByTemplateNameAndLocation(
            this.template,
            loc.zone
          ),
          assetRollout: this.generic_service.getAssetRolloutByTemplateNameAndLocation(
            this.template,
            loc.zone
          )
        });


      } else {

        return forkJoin({
          objectInfo: this.generic_service.getAllByLocationAndCid(
            loc.zone
          ),
          assetRollout: this.generic_service.getAssetRolloutByLocation(
            loc.zone
          )
        });

      }
    }
    );


    // forkJoin(requests).subscribe(
    //   (responses: any) => {
    //     for (const res of responses) {
    //       if (res.response != null) {
    //         this.objectInfoList.push(...res.response);
    //       }
    //     }


    //     this.initMap();

    //     if (this.map && this.objectInfoList.length > 0) {
    //       const latLngs = this.objectInfoList
    //         .filter((item: { lat: any; lng: any }) => item.lat && item.lng)
    //         .map((item: { lat: any; lng: any }) => [item.lat, item.lng]);

    //       if (latLngs.length > 0) {
    //         const bounds = L.latLngBounds(latLngs);
    //         this.map.fitBounds(bounds, {
    //           padding: [20, 20]
    //         });
    //         this.map.invalidateSize();
    //       }
    //     }
    //   },
    //   (err: any) => {
    //     console.log(err);
    //   }
    // );
    forkJoin(requests).subscribe(
      (responses: any) => {
        console.log(responses)

        for (const res of responses) {

          // Case when template is NOT empty
          if (this.template !== "") {
            if (res.objectInfo?.response) {
              this.objectInfoList.push(...res.objectInfo.response);
            }

            if (res.assetRollout?.response) {
              this.objectInfoList.push(...res.assetRollout.response);
              // OR push to a different list if needed
              // this.assetRolloutList.push(...res.assetRollout.response);
            }
          }
          // Case when template is empty
          else {
            // if (res?.response) {
            //   this.objectInfoList.push(...res.response);
            // }

            if (res.objectInfo?.response) {
              this.objectInfoList.push(...res.objectInfo.response);
            }

            if (res.assetRollout?.response) {
              this.objectInfoList.push(...res.assetRollout.response);
              // OR push to a different list if needed
              // this.assetRolloutList.push(...res.assetRollout.response);
            }
          }
        }

        console.log(this.objectInfoList)
        for (let list of this.objectInfoList) {
          if (list.assetRolloutId) {
            list.multiLatLng = true
          }
        }

        this.initMap();

        if (this.map) {
          let combinedBounds = L.latLngBounds([]);
          let hasBounds = false;

          if (this.objectInfoList.length > 0) {
            const latLngs = this.objectInfoList
              .filter((item: any) => item.lat && item.lng)
              .map((item: any) => [item.lat, item.lng]);

            if (latLngs.length > 0) {
              combinedBounds.extend(L.latLngBounds(latLngs));
              hasBounds = true;
            }
          }

          console.log("locationCheckList : ", this.locationCheckList)

          this.locationCheckList.forEach((loc: any) => {
            if (loc.lngLat && loc.lngLat.length > 0) {
              // Leaflet expects [latitude, longitude]. In the data, y is latitude and x is longitude.
              const polygonCoords = loc.lngLat.map((coord: any) => [coord.y, coord.x]);
              console.log("polygonCoords : ", polygonCoords)
              const polygon = L.polygon(polygonCoords).addTo(this.map);

              combinedBounds.extend(polygon.getBounds());
              hasBounds = true;
            }
          });

          if (hasBounds) {
            // Overriding initMap's 1.5s timeout to ensure bounds cover all polygons and markers
            setTimeout(() => {
              if (this.map) {
                this.map.fitBounds(combinedBounds, { padding: [20, 20] });
                this.map.invalidateSize();
              }
            }, 1600);
          }
        }
      },
      (err: any) => {
        console.log(err);
      }
    );


  }


  removeImage(index: any) {
    this.imagesWithDetails.splice(index, 1)
  }


  // locationCheck(event: any, list: any) {
  //   if (event.target.checked) {
  //     this.locationCheckList.push(list);
  //   } else {
  //     // Find index of the unchecked location in the list
  //     const index = this.locationCheckList.findIndex(
  //       (loc: any) => loc.locationId === list.locationId
  //     );
  //     if (index !== -1) {
  //       this.locationCheckList.splice(index, 1);
  //     }
  //   }
  //   this.objectInfoList = []
  //   for(let loc of this.locationCheckList){ 
  //     this.generic_service.getAllByLocationAndCid(loc.zone).subscribe(
  //       (res: any) => {
  //         if(res.response != null){
  //           for(let resList of res.response){
  //             this.objectInfoList.push(resList)
  //           }
  //         }
  //       },
  //       (err: any) => {
  //         console.log(err);
  //       }
  //     );
  //   }

  //   this.initMap();

  //   setTimeout(() => {
  //     if (this.map && this.objectInfoList.length > 0) {
  //       const latLngs = this.objectInfoList
  //         .filter((item: { lat: any; lng: any; }) => item.lat && item.lng)
  //         .map((item: { lat: any; lng: any; }) => [item.lat, item.lng]);

  //       if (latLngs.length > 0) {
  //         const bounds = L.latLngBounds(latLngs);
  //         this.map.fitBounds(bounds, { padding: [20, 20] });
  //         this.map.invalidateSize();
  //       }
  //     }
  //   }, 1000);
  // }


  getAllObjectInfoByLocationAndCid(location: any) {
    this.clearMapLayers()
    this.map.remove();
    this.generic_service.getAllByLocationAndCid(location).subscribe(
      (res: any) => {
        console.log('Location Result:', res);
        if (res.response == null || res.response.length == 0 || res.response == undefined) {
          this.objectInfoList = []
          this.initMap();

          return

        }
        this.objectInfoList = res.response
        this.initMap();



        setTimeout(() => {
          if (this.map && this.objectInfoList.length > 0) {
            const latLngs = this.objectInfoList
              .filter((item: { lat: any; lng: any; }) => item.lat && item.lng)
              .map((item: { lat: any; lng: any; }) => [item.lat, item.lng]);

            if (latLngs.length > 0) {
              const bounds = L.latLngBounds(latLngs);
              this.map.fitBounds(bounds, { padding: [20, 20] }); // optional padding
              this.map.invalidateSize();
            }
          }
        }, 1000);

      },
      (err: any) => {
        console.log(err);
      }
    );
  }

  getAllObjectInfo() {
    this.generic_service.getAllObjectInfo().subscribe(
      (response: any) => {
        console.log(response.response)

        this.objectInfoList = response.response
        this.objectInfoListFilter = response.response
        // this.initMap();

      },
      (error: any) => {
        console.log(error)
      }
    )
  }

  markerIcon = {
    icon: L.icon({
      iconSize: [25, 41],
      iconAnchor: [10, 41],
      popupAnchor: [2, -40],
      // specify the path here
      iconUrl: "https://unpkg.com/leaflet@1.5.1/dist/images/marker-icon.png",
      shadowUrl: "https://unpkg.com/leaflet@1.5.1/dist/images/marker-shadow.png"
    })
  };


  clearMapLayers() {
    // Remove drawn items
    this.map.eachLayer((layer: any) => {
      // Skip tile layers
      if (layer instanceof L.TileLayer) return;

      // Remove everything else (markers, polylines, GeoJSON, etc.)
      this.map.removeLayer(layer);
    });

    // Clear stored area points and flags
    this.area = [];
    this.multiLatLng = false;
    this.isObjectColorCode = false;
    this.layerType = '';

    // Reset GeoJSON features
    this.geojsonData = {
      type: "FeatureCollection",
      features: []
    };

    // Reset marker2 if used
    if (this.marker2) {
      this.map.removeLayer(this.marker2);
      this.marker2 = undefined;
    }

    // Optionally reset lat/lng if needed
    this.lat = undefined;
    this.lng = undefined;

    // Optionally reset the default center if needed
    // this.defaultCenter = [initialLat, initialLng];
  }


  private initMap(): void {

    if (this.map) {
      this.map.remove();
    }
    const singleData = this.singleObjectInfoData?.[0];

    if (singleData) {
      if (!singleData.multiLatLng) {
        if (singleData.lat && singleData.lat !== 0) {
          this.defaultCenter = [singleData.lat, singleData.lng];
        } else if (singleData.area?.length) {
          const firstPoint = singleData.area[0];
          this.defaultCenter = [firstPoint.lat, firstPoint.lng];
        }
      }
    } else {

      if (this.latestLoc.length != 0) {
        this.defaultCenter = this.latestLoc;
      } else {
        setTimeout(() => {
          if (this.map && this.objectInfoList.length > 0) {
            const latLngs = this.objectInfoList
              .filter((item: { lat: any; lng: any; }) => item.lat && item.lng)
              .map((item: { lat: any; lng: any; }) => [item.lat, item.lng]);

            if (latLngs.length > 0) {
              const bounds = L.latLngBounds(latLngs);
              this.map.fitBounds(bounds, {
                padding: [20, 20],
                maxZoom: 12
              }
              );
              this.map.invalidateSize();
            }
          }
        }, 1500);
      }

    }

    if (this.latestLoc.length != 0) {
      this.defaultCenter = this.latestLoc;
    }


    // Initialize Map
    this.map = L.map('map', {
      center: this.defaultCenter,
      zoom: this.defaultZoom
    });

    const tiles = L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', {
      maxZoom: 22,
      minZoom: 2,
      attribution: '&copy; <a href="http://www.openstreetmap.org/copyright">OpenStreetMap</a>'
    }).addTo(this.map);

    // Drawing Control
    const drawnItems = L.featureGroup().addTo(this.map);
    const drawControl = new L.Control.Draw({
      edit: { featureGroup: drawnItems },
      draw: {
        marker: true,
        polygon: false,
        polyline: true,
        circle: false,
        rectangle: false,
        circlemarker: false
      }
    });
    this.map.addControl(drawControl);

    // Drawing Event Handler
    this.map.on(L.Draw.Event.CREATED, (event: any) => {
      const layer = event.layer;

      if (event.layerType === "polyline") {
        this.layerType = "Polyline";
        this.multiLatLng = true;
        this.isObjectColorCode = true;
        this.area = layer._latlngs.map((p: any) => ({ lat: p.lat, lng: p.lng }));
        drawnItems.addLayer(layer);
      } else if (event.layerType === "marker") {
        this.layerType = "Marker";
        this.lat = layer._latlng.lat;
        this.lng = layer._latlng.lng;
        this.multiLatLng = false;
        this.isObjectColorCode = false;
        this.objectColorCode = ""
        this.area = [];

        if (this.marker2) {
          this.map.removeLayer(this.marker2);
        }
      }

      document.getElementById("add-device-popup")?.click();
    });

    // --- Render Markers or Lines ---

    if (singleData) {
      if (!singleData.multiLatLng) {
        if (singleData.lat && singleData.lat !== 0) {
          const iconUrl = singleData.icon || 'assets/image (1).png';
          const customHtmlIcon = L.divIcon({
            className: '',
            html: `
            <div style="
              position: relative;
              width: 60px;
              height: 60px;
              background: white;
              border: 3px solid #e94141ff;
              border-radius: 50%;
              overflow: hidden;
              box-shadow: 0 2px 6px rgba(0,0,0,0.3);
            ">
              <img src="${iconUrl}" style="width: 100%; height: 100%; object-fit: cover;" />
              <div style="
                position: absolute;
                bottom: -10px;
                left: 50%;
                transform: translateX(-50%);
                width: 0;
                height: 0;
                border-left: 10px solid transparent;
                border-right: 10px solid transparent;
                border-top: 15px solid #2c3e50;
              "></div>
            </div>
          `,
            iconAnchor: [30, 30],
            popupAnchor: [0, 0]
          });

          const markerPopup = this.compilePopup(PopupComponent, (c: any) => {
            c.instance.customData = singleData;
          });

          L.marker([singleData.lat, singleData.lng], { icon: customHtmlIcon })
            .addTo(this.map)

        } else {
          this.toastr.error("No location available");
        }
      } else if (singleData.area?.length) {
        const latlngs = singleData.area.map((p: any) => [parseFloat(p.lng), parseFloat(p.lat)]);
        const feature = {
          type: "Feature",
          color: singleData.objectColorCode || 'black',
          properties: singleData,
          geometry: {
            type: "LineString",
            coordinates: latlngs
          }
        };

        this.geojsonData.features.push(feature);

        L.geoJSON(feature, {
          style: { color: feature.color, weight: 14 }
        }).addTo(this.map)
          .on('click', () => this.onMarkerClick(singleData));
      }
    } else {
      // Multiple objects
      for (const obj of this.objectInfoList) {
        const iconUrl = obj.icon || 'assets/image (1).png';
        const customHtmlIcon = L.divIcon({
          className: '',
          html: `
          <div style="
            position: relative;
            width: 60px;
            height: 60px;
            background: white;
            border: 3px solid rgb(196, 192, 192);
            border-radius: 50%;
            overflow: hidden;
            // box-shadow: 0 2px 6px rgba(0,0,0,0.3);
          ">
            <img src="${iconUrl}" style="width: 100%; height: 100%; object-fit: cover;" />
            <div style="
              position: absolute;
              bottom: -10px;
              left: 50%;
              transform: translateX(-50%);
              width: 0;
              height: 0;
              border-left: 10px solid transparent;
              border-right: 10px solid transparent;
              // border-top: 15px solid #2c3e50;
            "></div>
          </div>
        `,
          iconAnchor: [30, 30],
          popupAnchor: [0, 0]
        });

        const customHtmlIconRed = L.divIcon({
          className: '',
          html: `
          <div style="
            position: relative;
            width: 60px;
            height: 60px;
            background: white;
            border: 3px solid #e94141ff;
            border-radius: 50%;
            overflow: hidden;
            // box-shadow: 0 2px 6px rgba(0,0,0,0.3);
          ">
            <img src="${iconUrl}" style="width: 100%; height: 100%; object-fit: cover;" />
            <div style="
              position: absolute;
              bottom: -10px;
              left: 50%;
              transform: translateX(-50%);
              width: 0;
              height: 0;
              border-left: 10px solid transparent;
              border-right: 10px solid transparent;
              // border-top: 15px solid #2c3e50;
            "></div>
          </div>
        `,
          iconAnchor: [30, 30],
          popupAnchor: [0, 0]
        });



        const customHtmlIconGreen = L.divIcon({
          className: '',
          html: `
          <div style="
            position: relative;
            width: 60px;
            height: 60px;
            background: white;
            border: 3px solid green;
            border-radius: 50%;
            overflow: hidden;
            // box-shadow: 0 2px 6px rgba(0,0,0,0.3);
          ">
            <img src="${iconUrl}" style="width: 100%; height: 100%; object-fit: cover;" />
            <div style="
              position: absolute;
              bottom: -10px;
              left: 50%;
              transform: translateX(-50%);
              width: 0;
              height: 0;
              border-left: 10px solid transparent;
              border-right: 10px solid transparent;
              // border-top: 15px solid #2c3e50;
            "></div>
          </div>
        `,
          iconAnchor: [30, 30],
          popupAnchor: [0, 0]
        });

        if (!obj.multiLatLng) {
          if (obj.lat && obj.lat !== 0) {
            const markerPopup = this.compilePopup(PopupComponent, (c: any) => {
              c.instance.customData = obj;
            });

            let icon: any = customHtmlIcon
            if (obj.assetMonitoring) {
              if (obj.alive) {
                icon = customHtmlIconGreen
              } else {
                icon = customHtmlIconRed
              }
            }


            L.marker([obj.lat, obj.lng], { icon: icon })
              .addTo(this.map)
              .on('click', () => this.onMarkerClick(obj))

              .on('mousemove', (e: any) => {
                const latlng = e.latlng;
                hoverMarker.setLatLng(latlng);

                if (!this.map.hasLayer(hoverMarker)) {
                  hoverMarker.addTo(this.map);
                }
              })

              .on('mouseout', () => {
                if (this.map.hasLayer(hoverMarker)) {
                  this.map.removeLayer(hoverMarker);
                }
              });

            const hoverMarker = L.marker([0, 0], {
              icon: L.divIcon({
                className: 'hover-marker',
                html: `
      <div style="
        position: relative;
        width: 240px;
        background: #fdfdfd;
        border: 1px solid #d6e4f0;
        border-radius: 10px;
        padding: 14px 16px;
        font-family: 'Segoe UI', Tahoma, sans-serif;
        font-size: 14px;
        color: #2c3e50;
        box-shadow: 0 4px 12px rgba(0,0,0,0.1);
      ">
        <div style="display: flex; margin-bottom: 8px;">
          <span style="font-weight: 600; width: 90px; color:#34495e;">Asset Id</span>
          <span style="margin: 0 6px; font-weight: bold; color:#7f8c8d;">:</span>
          <span>${obj.objectInfoId || '--'}</span>
        </div>
        <div style="display: flex; margin-bottom: 8px;">
          <span style="font-weight: 600; width: 90px; color:#34495e;">Asset</span>
          <span style="margin: 0 6px; font-weight: bold; color:#7f8c8d;">:</span>
          <span>${obj.givenName || '--'}</span>
        </div>
        <div style="display: flex; margin-bottom: 8px;">
          <span style="font-weight: 600; width: 90px; color:#34495e;">Condition</span>
          <span style="margin: 0 6px; font-weight: bold; color:#7f8c8d;">:</span>
          <span>${obj.objectCondition || '--'}</span>
        </div>
        <div style="display: flex; margin-bottom: 8px;">
          <span style="font-weight: 600; width: 90px; color:#34495e;">Location</span>
          <span style="margin: 0 6px; font-weight: bold; color:#7f8c8d;">:</span>
          <span>${obj.location || '--'}</span>
        </div>
        <div style="display: flex;">
          <span style="font-weight: 600; width: 90px; color:#34495e;">Branch</span>
          <span style="margin: 0 6px; font-weight: bold; color:#7f8c8d;">:</span>
          <span>${obj.branch || '--'}</span>
        </div>
        
        <!-- caret (arrow) -->
        <div style="
          position: absolute;
          bottom: -12px;
          left: 50%;
          transform: translateX(-50%);
          width: 0;
          height: 0;
          border-left: 12px solid transparent;
          border-right: 12px solid transparent;
          border-top: 12px solid #fdfdfd;
          filter: drop-shadow(0 -1px 1px rgba(0,0,0,0.15));
        "></div>
      </div>
    `,
                iconAnchor: [120, 210],
              }),
              interactive: false
            });




            //     const hoverMarker = L.marker([0, 0], {
            //   icon: L.divIcon({
            //     className: '',
            //     html: `
            //       <div style="
            //         position: relative;
            //         width: 200px;
            //         height: 100px;
            //         background: white;
            //         border: 1px solid #2c3e50;
            //         border-radius: 5px;
            //         overflow: hidden;
            //         padding: 20px 20px;
            //         box-shadow: 0 1px 4px rgba(0,0,0,0.3);
            //         z-index: 1000
            //         ">
            //         <div 
            //         style="
            //         display: flex;
            //         ">
            //           <p style="font-size: 16px;width: 70px">Asset Id</p>
            //           <p style="font-size: 16px;padding: 0 10px">:</p>
            //           <p style="font-size: 16px">${obj.objectInfoId || '--'}</p>
            //         </div>
            //         <div 
            //           style="
            //         display: flex;">
            //           <p style="font-size: 16px;width: 70px">Asset</p>
            //           <p style="font-size: 16px;padding: 0 10px">:</p>
            //           <p style="font-size: 16px">${obj.givenName || '--'}</p>
            //         </div>
            //       </div>
            //     `,
            //     iconAnchor: [100, 130],
            //   }),
            //   interactive: false
            // });


            // const hoverMarker = L.marker([0, 0], {
            //   icon: L.divIcon({
            //     className: '',
            //     html: `
            //       <div style="
            //         position: relative;
            //         width: 200px;
            //         height: 200px;
            //         background: white;
            //         border: 2px solid #2c3e50;
            //         overflow: hidden;
            //         box-shadow: 0 1px 4px rgba(0,0,0,0.3);
            //       ">
            //             <div class="data-block">
            //     <p>Asset Id</p>
            //     <p>:</p>
            //     <p>{{data.objectInfoId || '--'}}</p>
            // </div>
            // <div class="data-block">
            //     <p>Asset</p>
            //     <p>:</p>
            //     <p>{{data.name || '--'}}</p>
            // </div>
            //       </div>
            //     `,
            //     iconAnchor: [20, 20],
            //   }),
            //   interactive: false // so it doesn't block mouse events
            // });

            // Mouse move on line — update marker position and add to map


            // const marker = L.marker([obj.lat, obj.lng], { icon: customHtmlIcon })
            //   .addTo(this.map)
            //   .bindPopup(PopupComponent);

            // Show popup on hover


            // markerPopup.bindPopup(`
            //   <div style="text-align: center;">
            //     <img src="assets/img/dummy-image.jpeg" style="width: 150px; border-radius: 8px;" />
            //     <p>End of the route</p>
            //   </div>
            // `);

          }
        } else if (obj.area?.length) {
          const latlngs = obj.area.map((p: any) => [parseFloat(p.lng), parseFloat(p.lat)]);
          const feature = {
            type: "Feature",
            color: obj.objectColorCode || 'black',
            properties: obj,
            geometry: {
              type: "LineString",
              coordinates: latlngs
            }
          };

          this.geojsonData.features.push(feature);

          L.geoJSON(feature, {
            style: { color: feature.color, weight: 10 }
          }).addTo(this.map)
            .on('click', () => this.onMarkerClick(obj));
        }
      }




    }

    // Final GeoJSON Render (in case any features were added manually)
    if (this.geojsonData.features && this.geojsonData.features.length != 0) {

      this.geojsonData.features.forEach((feature: any) => {
        L.geoJSON(feature, {
          style: { color: feature.color || 'black', weight: 7 }
        }).addTo(this.map)
          .on('click', () => this.onMarkerClick(feature.properties));
      });
    }

  }


  filterObjectByTemplate(name: any) {
    console.log(name)
    let filterList = this.objectInfoListFilter.filter((list: any) => {
      if (name === list.name) {
        console.log(list)
        return list
      }
    })
    this.objectInfoList = filterList
    this.initMap();

  }



  depreciationMethodChange(depreciationMethod: any) {

    let method: any = ""
    for (let list of this.assetDepreciationDataList) {
      if (list.assetDepreciationMethodId == Number(depreciationMethod)) {
        method = list.methodName
      }
    }

    console.log(method)
    this.isOriginalCost = false;
    this.isAsset_Category = false;
    // this.isPutToUseDate = false;
    this.isSalvageValue = false;
    this.isAssetLifeNumber = false;

    if (method == "Written Down Value (WDV)") {
      this.isOriginalCost = true;
      this.isAsset_Category = true;
      // this.isPutToUseDate = true;
    }

    if (method == "Straight Line Method (SLM)") {
      this.isOriginalCost = true;
      // this.isPutToUseDate = true;
      this.isSalvageValue = true;
      this.isAssetLifeNumber = true;
    }
  }


  remove() {
    this.map.removeLayer(this.layerInfoLatLng);
    this.form.reset()
    this.imagesList = []
    this.imagesWithDetails = []
    this.area = []
    this.multiLatLng = false
    this.singleObjectTemplateData = []
    this.objectTemplateId = ""
    this.originalCost = ""
    this.currentCost = ""
    this.branch = ""
    this.department = ""
    this.objectCondition = ""
    this.assetStatus = ""
    this.givenName = ""
    this.location = ""
    this.serialNumber = ""
    this.maintenanceList = []
    this.imagesList = []
    this.imagesWithDetails = []
    this.assetHealth = false
    this.assetMonitoring = false
    this.connectionsList = []
    this.assetHealthList = []
    this.isClone = false



    this.objectInfoId = ""



    this.singleObjectInfoData = []
    this.imagesList = []
    this.imagesWithDetails = []
    this.singleObjectTemplateData = []


    this.templateName = "";
    this.originalCost = null;
    this.objectCondition = "";
    this.assetStatus = ""
    this.givenName = "";
    this.serialNumber = "";
    this.imagesList = [];
    this.imagesWithDetails = []
    this.icon = "";
    this.currentCost = null;
    this.branch = "";
    this.department = "";
    this.make = "";
    this.model = "";
    this.location = "";
    this.assetMonitoring = false;
    this.connectionsList = [];
    this.assetHealthList = [];
    this.assetHealth = false
    this.assetMonitoringFrequency = null;
    this.assetMonitoringTimeSpan = null;
    this.nameValue = [];
    this.performanceMatrix = [];
    this.acquisitionDate = "";
    this.salvageValue = null;
    this.depreciationMethod = null;
    this.assetLifeNumber = null;
    this.asset_Category = "";
    this.tags = []
    document.getElementById("closeModalButton")?.click()
    this.closeDetailView()
    this.proofFile = ""
    this.proofFilePath = ""
    this.proofFileType = ""
  }



  defaultIcon = L.icon({
    iconUrl: 'assets/image (1).png', // your path may vary ...
    iconSize: [80, 80],
    iconAnchor: [30, 2],
    popupAnchor: [0, -2]
  });

  ngOnDestroy() {
    this.map.remove();
  }

  onMarkerClick(objectInfo: any) {
    this.isFullscreen = false;
    console.log(objectInfo)
    // if(objectInfo.assetRolloutId){

    // }else{
    //   this.viewObject(objectInfo.objectInfoId)
    // }

    this.viewObject(objectInfo.objectInfoId)

  }

  viewRolloutAsset(assetRolloutId: any) {
    this.showFilter = false;
    this.detailShow = true;

    this.generic_service.getAssetRolloutByRolloutId(assetRolloutId).subscribe(
      (response: any) => {
        this.singleObjectInfoData = [];
        this.singleObjectInfoData.push(response.response);
        this.imagesList = response.response.imagesWithDetails;
        this.imagesWithDetails = response.response.imagesWithDetails;

      },
      (error: any) => {
        console.log(error);
      }
    );
  }

  closeDetailView() {
    // this.map.remove();
    this.showFilter = false
    this.detailShow = false

    this.singleObjectInfoData = []
    setTimeout(() => {
      if (this.map) {
        this.map.invalidateSize();
        this.map.setView(this.defaultCenter, this.map.getZoom());
      }
    }, 500);


    if (this.latestLoc.length != 0) {
      this.defaultCenter = this.latestLoc;

      setTimeout(() => {
        if (this.map && this.latestLoc.length > 0) {
          const latLngs = this.latestLoc

          if (latLngs.length > 0) {
            const bounds = L.latLngBounds(latLngs);
            this.map.fitBounds(bounds);
            this.map.setView(this.latestLoc, 16);
            this.map.invalidateSize();
          }
        }
      }, 500);


    } else {
      setTimeout(() => {
        if (this.map && this.objectInfoList.length > 0) {
          const latLngs = this.objectInfoList
            .filter((item: { lat: any; lng: any; }) => item.lat && item.lng)
            .map((item: { lat: any; lng: any; }) => [item.lat, item.lng]);

          if (latLngs.length > 0) {
            const bounds = L.latLngBounds(latLngs);
            this.map.fitBounds(bounds, { padding: [20, 20] });
            this.map.invalidateSize();
          }
        }
      }, 500);
    }



    this.initMap()

    this.toggleFullscreen()


  }

  parentsObjects: any[] = [];

  // getParentData(objectInfoId: any): void {
  //   this.generic_service.getObjectInfoById(objectInfoId).subscribe(
  //     (response: any) => {
  //       const data = response?.response;

  //       if (data && data.lat && data.lat !== 0) {
  //         this.parentsObjects.push(data);

  //         const parentId = data.parentAssetId;
  //         if (parentId && parentId !== 0) {
  //           this.getParentData(parentId);
  //         }
  //       }
  //     },
  //     (error: any) => {
  //       console.error('Error fetching parent data:', error);
  //     }
  //   );
  // }

  private parentLineLayer?: any;  // Store reference to the current polyline

  async getParent1(objectInfoId: any): Promise<void> {
    this.parentsObjects = [];
    console.log("parent")

    let currentId = objectInfoId;

    // --- Step 1: Loop to fetch all parent objects ---
    while (currentId) {
      try {
        const response: any = await this.generic_service.getObjectInfoById(currentId).toPromise();
        const data = response?.response;

        if (!data || !data.lat || data.lat === 0) {
          break;
        }

        this.parentsObjects.push(data);

        if (data.parentAssetId && data.parentAssetId !== 0) {
          currentId = data.parentAssetId;
        } else {
          break;
        }

      } catch (error) {
        console.error('Error fetching parent data:', error);
        break;
      }
    }

    // --- Step 2: Remove existing polyline (if any) ---
    if (this.parentLineLayer) {
      this.map.removeLayer(this.parentLineLayer);
    }

    // --- Step 3: If we have valid parent data, build LineString for map ---
    if (this.parentsObjects?.length) {
      const latlngs: L.LatLngExpression[] = [];
      const geometry: any = {
        type: "FeatureCollection",
        features: []
      };

      const feature: any = {
        type: "Feature",
        color: "#e94141ff",
        properties: {
          name: "Polygon 1"
        },
        geometry: {
          type: "LineString",
          coordinates: []
        }
      };

      for (const obj of this.parentsObjects) {
        if (obj.lat && obj.lng) {
          latlngs.push([
            parseFloat(obj.lng),
            parseFloat(obj.lat)
          ]);
        }
      }

      feature.geometry.coordinates = latlngs;
      geometry.features.push(feature);

      // --- Step 4: Add new polyline and store reference ---
      this.parentLineLayer = L.geoJSON(feature, {
        style: {
          color: feature.color,
          weight: 30
        }
      }).addTo(this.map);

      setTimeout(() => {
        if (this.map && this.parentsObjects.length > 0) {
          const latLngs = this.parentsObjects
            .filter((item: { lat: any; lng: any; }) => item.lat && item.lng)
            .map((item: { lat: any; lng: any; }) => [item.lat, item.lng]);

          if (latLngs.length > 0) {
            const bounds = L.latLngBounds(latLngs);
            this.map.fitBounds(bounds, { padding: [20, 20] },

            ); // optional padding
            this.map.invalidateSize();
          }
        }
      }, 500);
    }

    console.log('Final parents:', this.parentsObjects);
  }




  viewObject(objectInfoId: any) {
    this.showFilter = false;
    this.detailShow = true;
    this.objectInfoId = objectInfoId;

    this.generic_service.getObjectInfoById(objectInfoId).subscribe(
      (response: any) => {
        this.singleObjectInfoData = [];
        this.singleObjectInfoData.push(response.response);
        this.imagesList = response.response.images;
        this.imagesWithDetails = response.response.imagesWithDetails;
        this.latestLoc = []
        if (response.response.lat && response.response.lat !== 0) {
          this.getParent(objectInfoId);

          // Wait until Angular renders the map container
          setTimeout(() => {
            if (this.map) {
              this.map.invalidateSize(); // Fixes blank map
              this.map.setView(
                [response.response.lat, response.response.lng], 16);
              this.latestLoc = [response.response.lat, response.response.lng]
              // Add marker explicitly (if not already added)
              // L.marker([response.response.lat, response.response.lng]).addTo(this.map);
            }
          }, 1000); // small delay ensures container is visible
        }
      },
      (error: any) => {
        console.log(error);
      }
    );
  }


  getObjectInfoById(objectInfoId: any) {
    this.showFilter = false
    this.detailShow = true
    this.objectInfoId = objectInfoId
    this.generic_service.getObjectInfoById(objectInfoId).subscribe(
      (response: any) => {
        this.map.remove();

        this.singleObjectInfoData = []
        this.singleObjectInfoData.push(response.response)
        this.imagesList = response.response.images
        this.imagesWithDetails = response.response.imagesWithDetails
        // this.geojsonData.features[0].geometry.coordinates = latlang[0]
        // this.geojsonData.features[0].geometry.type = "Point"

        // console.log(this.geojsonData)

        this.initMap()


      },
      (error: any) => {
        console.log(error)
      }
    )
  }



  addMaintenance() {
    this.maintenanceList.push(
      {
        "description": "",
        "maintenanceType": "",
        "frequency": "",
        "nextDueDate": "",
        "lastPerformed": "",
      }
    )
  }

  removeMaintenance(index: any) {
    this.maintenanceList.splice(index, 1)
  }

  addMaintenanceSchedule(body: any) {
    console.log(body)
    this.generic_service.addMaintenanceSchedule(body).subscribe(
      (response: any) => {
        console.log(response)
      },
      (error: any) => {
        this.toastr.error(error.error.errors[0].description);
        console.log(error)
      }
    )
  }


  addObjectInfo() {

    if (
      this.givenName == "" ||
      this.objectCondition == "" ||
      this.objectTemplateId == "" ||
      // this.asset_Category == "" ||
      this.location == ""
      // this.acquisitionDate == "" ||
      // this.salvageValue == "" ||
      // this.depreciationMethod == "" ||
      // this.assetLifeNumber == ""

    ) {
      this.toastr.error("Please fill in all required fields");

      return
    }


    let method: any = ""
    for (let list of this.assetDepreciationDataList) {
      if (list.assetDepreciationMethodId == this.depreciationMethod) {
        method = list.methodName
      }
    }

    if (this.singleObjectTemplateData[0]?.depreciationRequired) {
      if (method == "Written Down Value (WDV)") {
        if (
          this.originalCost == ""
        ) {
          this.toastr.error("Please fill in all required fields");
          return
        }
      }

      if (method == "Straight Line Method (SLM)") {
        if (
          this.originalCost == ""
        ) {
          this.toastr.error("Please fill in all required fields");
          return
        }
      }
    }

    if (!this.assetMonitoring) {
      this.connectionsList = []
    }

    if (!this.assetHealth) {
      this.assetHealthList = []
    }

    let tags: any = []
    for (let list of this.tags) {
      if (list.tag != "") {
        tags.push(list.tag)
      }
    }


    for (let list of this.branchList) {
      if (list.name == this.branch) {
        this.branchId = list.branchMasterId
      }
    }

    let loc: any
    // for(let list of this.locationList){
    //   if(list.zone == this.location){
    //     loc = list
    //   }
    // }

    for (let list of this.locationFilterList) {
      if (list.zone == this.location) {
        loc = list
      }
    }



    let parentAssetId: any = []

    for (let list of this.parentSelectedList) {
      parentAssetId.push(list.objectInfoId)
    }

    let currentWarrantyInfo = this.singleObjectTemplateData[0]?.warrantyInfo;
    if (currentWarrantyInfo) {
      for (let list of currentWarrantyInfo) {
        if (list.key == "Coverage Start Date" || list.key == "Coverage End Date") {
          if (list.value) {
            list.value = new Date(list.value).getTime();
          }
        }
      }
    }

    let body = {
      "version": 0,
      "isActive": true,
      "description": "locate asset",
      "layerInfoId": 0,
      "name": this.singleObjectTemplateData[0]?.name,
      "type": this.singleObjectTemplateData[0]?.type,
      "group": this.singleObjectTemplateData[0]?.group,
      "originalCost": this.originalCost,
      "objectCondition": this.objectCondition,
      "assetStatus": this.assetStatus,
      "givenName": this.givenName,
      "serialNumber": this.serialNumber,
      "conditionModifiedBy": [],
      "currentCost": this.currentCost,
      "branch": this.branch,
      "branchId": this.branchId,
      "icon": this.icon,
      "images": this.imagesList,
      "imagesWithDetails": this.imagesWithDetails,
      "department": this.department,
      "lat": this.lat,
      "lng": this.lng,
      "make": this.make,
      "model": this.model,
      "country": loc.country,
      "provinceOrState": loc.provinceOrState,
      "district": loc.district,
      "zone": loc.zone,
      "postalCode": loc.postalCode,
      "city": loc.city,
      "location": this.location,
      "routeId": this.singleObjectTemplateData[0]?.routeId,
      "subGroups": this.singleObjectTemplateData[0]?.subGroups,
      "nameValue": this.singleObjectTemplateData[0]?.nameValue,
      "performanceMatrix": this.singleObjectTemplateData[0]?.performanceMatrix,
      "cid": this.singleObjectTemplateData[0]?.cid,
      "repairInfos": [],
      "multiLatLng": this.multiLatLng,
      "area": this.area,
      "assetMonitoring": this.assetMonitoring,
      "connectionDetails": this.connectionsList,
      "assetMonitoringFrequency": this.assetMonitoringFrequency,
      "assetMonitoringTimeSpan": this.assetMonitoringTimeSpan,
      "assetHealth": this.assetHealthList,
      "acquisitionDate": this.acquisitionDate,
      "salvageValue": this.salvageValue,
      "depreciationMethod": this.depreciationMethod,
      "assetLifeNumber": this.assetLifeNumber,
      "asset_Category": this.asset_Category,
      "objectColorCode": this.objectColorCode || '',
      "tags": tags,
      "holding": [
        {
          "allocationRegisterId": 0,
          "userId": 0,
          "name": "COMPANY",
          "date": new Date().getTime()
        }
      ],
      "latestHolding": {
        "allocationRegisterId": 0,
        "userId": 0,
        "name": "COMPANY",
        "date": new Date().getTime()
      },
      "objectQty": this.objectQty,
      "objectUOM": this.objectUOM,
      "availableQty": this.objectQty,
      "parentAssetId": parentAssetId,
      "childAssetId": [],
      "performance": this.performance,
      "assetPerformance": {
        "timeSpan": this.timeSpan,
        "expectedOutput": this.expectedOutput,
        "uom": this.uom
      },
      "warrantyInfo": this.singleObjectTemplateData[0]?.warrantyInfo,
      "purchaseInfo": this.singleObjectTemplateData[0]?.purchaseInfo,
      "branchCheckBox": this.singleObjectTemplateData[0]?.branchCheckBox,
      "departmentCheckBox": this.singleObjectTemplateData[0]?.departmentCheckBox,
      "locationCheckBox": this.singleObjectTemplateData[0]?.locationCheckBox,
      "makeCheckBox": this.singleObjectTemplateData[0]?.makeCheckBox,
      "modelCheckBox": this.singleObjectTemplateData[0]?.modelCheckBox,
      "originalCostCheckBox": this.singleObjectTemplateData[0]?.originalCostCheckBox,
      "currentCostCheckBox": this.singleObjectTemplateData[0]?.currentCostCheckBox,
      "serialNumberCheckBox": this.singleObjectTemplateData[0]?.serialNumberCheckBox,
      "depreciationCheckbox": this.singleObjectTemplateData[0]?.depreciationCheckbox,
      "deploy": this.singleObjectTemplateData[0]?.deploy,
      "quantity": this.singleObjectTemplateData[0]?.quantity,
      "warranty": this.singleObjectTemplateData[0]?.warranty,
      "purchase": this.singleObjectTemplateData[0]?.purchase,

      "stockPointStatus": loc.stockPoint || false,
      "stockPointId": loc.locationId || 0,
      "stockPointName": loc.zone || "",





      "addDeleteIdsObjectInfo": {
        "assetIds": parentAssetId,
        "add": true,
        "parentIds": true
      },
      "quantityCheckBox": this.singleObjectTemplateData[0]?.quantity,
      "alive": this.alive,
      "deployCurrentLocation": this.deployCurrentLocation,
      "available": true
    }

    console.log(body)
    this.generic_service.addObjectInfo(body).subscribe(
      (response: any) => {
        console.log(response)
        document.getElementById("closeModalButton")?.click()
        document.getElementById("closeModalButton1")?.click()
        this.toastr.success(response.message);
        this.getAllObjectInfo()

        this.initMap()

        for (let list of this.maintenanceList) {
          let body = {
            "version": 0,
            "isActive": true,
            "description": list.description,
            "assetId": response.response.objectInfoId,
            "assetName": response.response.givenName,
            "maintenanceType": [
              list.maintenanceType,
            ],
            "frequency": [
              list.frequency,
            ],
            "nextDueDate": list.nextDueDate,
            "lastPerformed": "",
            "cid": Number(this.cid)
          }

          this.addMaintenanceSchedule(body)
        }


        this.deployCurrentLocation = false
        this.toastr.success(response.message);
        this.singleObjectTemplateData = []
        this.originalCost = ""
        this.currentCost = ""
        this.branch = ""
        this.department = ""
        this.objectCondition = ""
        this.assetStatus = ""
        this.givenName = ""
        this.location = ""
        this.serialNumber = ""
        this.maintenanceList = []
        this.imagesList = []
        this.imagesWithDetails = []
        this.area = []
        this.multiLatLng = false
        this.lat = 0
        this.lng = 0
        this.proofFile = ""
        this.proofFilePath = ""
        this.proofFileType = ""
      },
      (error: any) => {
        this.toastr.error(error.error.errors[0].description);
        console.log(error)
      }
    )
  }

  getAllObjectTemplate() {
    this.generic_service.getAllObjectTemplate().subscribe(
      (response: any) => {
        console.log(response)
        this.objectTemplateList = response.response
      },
      (error: any) => {
        console.log(error)
      }
    )
  }

  getObjectTemplateById(objectTemplateId: any) {
    console.log(objectTemplateId.target.value)
    this.generic_service.getObjectTemplateById(objectTemplateId.target.value).subscribe(
      (response: any) => {
        console.log(response)
        this.singleObjectTemplateData = []

        this.icon = response.response?.iconUrl || '';

        this.singleObjectTemplateData.push(response.response)
      },
      (error: any) => {
        console.log(error)
      }
    )
  }


  compilePopup(component: any, onAttach: any): any {
    const compFactory: any = this.resolver.resolveComponentFactory(component);
    let compRef: any = compFactory.create(this.injector);

    // onAttach allows you to assign 
    if (onAttach)
      onAttach(compRef);

    this.appRef.attachView(compRef.hostView);
    compRef.onDestroy(() => this.appRef.detachView(compRef.hostView));

    let div = document.createElement('div');
    div.appendChild(compRef.location.nativeElement);
    return div;
  }







  getAllModelByAndCid(model: any) {
    this.generic_service.getAllModelByAndCid(model).subscribe(
      (res: any) => {
        console.log('Model Result:', res);
        if (res.response == null || res.response.length == 0 || res.response == undefined) {
          this.objectInfoList = []
          return
        }
        this.objectInfoList = res.response
        this.initMap();

      },
      (err: any) => {
        console.log('Model Error:', err);
      }
    );
  }

  getAllAssetStatus() {
    this.generic_service.getAllAssetStatus().subscribe(
      (res: any) => {
        console.log(res)
        this.assetStatusList = res.response
      },
      (err: any) => {
        console.log(err)
      }
    )
  }

  getAllMakeByAndCid(make: any) {
    this.generic_service.getAllMakeByAndCid(make).subscribe(
      (res: any) => {
        console.log('Make Result:', res);
        if (res.response == null || res.response.length == 0 || res.response == undefined) {
          this.objectInfoList = []
          return

        }
        this.objectInfoList = res.response
        this.initMap();

      },
      (err: any) => {
        console.log('Make Error:', err);
      }
    );
  }

  getAllByType(type: any) {
    this.generic_service.getAllByType(type).subscribe(
      (res: any) => {
        console.log('Type Result:', res);
        if (res.response == null || res.response.length == 0 || res.response == undefined) {
          this.objectInfoList = []
          return

        }
        this.objectInfoList = res.response
        this.initMap();

      },
      (err: any) => {
        console.log('Type Error:', err);
      }
    );
  }

  getAllBySerialNumberAndCid(serialNumber: any) {
    this.generic_service.getAllBySerialNumberAndCid(serialNumber).subscribe(
      (res: any) => {
        console.log('Serial Number Result:', res);
        if (res.response == null || res.response.length == 0 || res.response == undefined) {
          this.objectInfoList = []
          return

        }
        this.objectInfoList = res.response
        this.initMap();

      },
      (err: any) => {
        console.log('Serial Number Error:', err);
      }
    );
  }

  getAllByObjectConditionAndCid(objectCondition: any) {
    this.generic_service.getAllByObjectConditionAndCid(objectCondition).subscribe(
      (res: any) => {
        console.log('Object Condition Result:', res);
        if (res.response == null || res.response.length == 0 || res.response == undefined) {
          this.objectInfoList = []
          return

        }
        this.objectInfoList = res.response
        this.initMap();

      },
      (err: any) => {
        console.log('Object Condition Error:', err);
      }
    );
  }

  getAllByBranchAndCid(branch: any): void {
    this.generic_service.getAllByBranchAndCid(branch).subscribe(
      (res: any) => {
        console.log('Branch Result:', res);

        const data = res?.response;

        if (!Array.isArray(data) || data.length === 0) {
          this.objectInfoList = [];
          return;
        }

        this.objectInfoList = data;
        this.initMap();

        setTimeout(() => {
          if (this.map && this.objectInfoList.length > 0) {
            const latLngs = this.objectInfoList
              .filter((item: { lat: any; lng: any; }) => item.lat && item.lng)
              .map((item: { lat: any; lng: any; }) => [item.lat, item.lng]);

            if (latLngs.length > 0) {
              const bounds = L.latLngBounds(latLngs);
              this.map.fitBounds(bounds, { padding: [20, 20] }); // optional padding
              this.map.invalidateSize();
            }
          }
        }, 500);
      },
      (err: any) => {
        console.error('Branch Error:', err);
        this.objectInfoList = []; // Optional: clear list on error
      }
    );
  }


  getAllByDepartmentAndCid(department: any) {
    this.generic_service.getAllByDepartmentAndCid(department).subscribe(
      (res: any) => {
        console.log('Department Result:', res);
        if (res.response == null || res.response.length == 0 || res.response == undefined) {
          this.objectInfoList = []
          return

        }
        this.objectInfoList = res.response
        this.initMap();

      },
      (err: any) => {
        console.log('Department Error:', err);
      }
    );
  }

  getAllByGroup(group: any) {
    this.generic_service.getAllByGroup(group).subscribe(
      (res: any) => {
        console.log('Group Result:', res);
        if (res.response == null || res.response.length == 0 || res.response == undefined) {
          this.objectInfoList = []
          return

        }
        this.objectInfoList = res.response
        this.initMap();

      },
      (err: any) => {
        console.log('Group Error:', err);
      }
    );
  }

  getAllObjectInfoByGroupAndType(group: any, type: any) {
    this.generic_service.getAllObjectInfoByGroupAndType(group, type).subscribe(
      (res: any) => {
        console.log('Group and Type Result:', res);
        if (res.response == null || res.response.length == 0 || res.response == undefined) {
          this.objectInfoList = []

          return

        }
        this.objectInfoList = res.response
      },
      (err: any) => {
        console.log('Group and Type Error:', err);
      }
    );
  }

  toggleFilter() {
    this.detailShow = false
    this.showFilter = !this.showFilter
  }

  refreshTickets() {
    this.singleObjectInfoData = []
    this.showFilter = false
    this.detailShow = false
    this.searchFilter = ""
    this.resetFilter()
    this.clearObject()
    this.closeDetailView()
  }

  resetFilter() {
    this.selectedFilter = ""

    this.modelFilter = "";
    this.locationFilter = "";
    this.makeFilter = "";
    this.typeFilter = "";
    this.serialNumberFilter = "";
    this.objectConditionFilter = "";
    this.branchFilter = "";
    this.departmentFilter = "";
    this.groupFilter = "";

    this.modelChecked = false;
    this.makeChecked = false;
    this.typeChecked = false;
    this.groupChecked = false;
    this.serialNumberChecked = false;
    this.objectConditionChecked = false;
    this.branchChecked = false;
    this.locationChecked = false;
    this.departmentChecked = false;
    this.departmentChecked = false;
    this.objectInfoList = []
    this.objectInfoListFilter = []
    // this.getAllObjectInfo()
  }

  getAllTypeList() {
    this.generic_service.getAllTypeList().subscribe(
      (res: any) => {
        console.log(res)
        this.objectTypeData = res.response
      },
      (err: any) => {
        console.log(err)
      }
    )
  }

  getAllGroupList() {
    this.generic_service.getAllGroupList().subscribe(
      (res: any) => {
        console.log(res)
        this.objectGroupData = res.response
      },
      (err: any) => {
        console.log(err)
      }
    )
  }


  modelChecked = false;
  modelFilter = "";

  makeChecked = false;
  makeFilter = "";

  typeChecked = false;
  typeFilter = "";

  serialNumberChecked = false;
  serialNumberFilter = "";

  objectConditionChecked = false;
  objectConditionFilter = "";

  branchChecked = false;
  branchFilter = "";

  locationChecked = false;
  locationFilter = "";

  departmentChecked = false;
  departmentFilter = ""


  objectByTemplateChecked = false;
  objectByTemplateFilter = "";

  groupChecked = false;
  groupFilter = "";

  selectedFilter = "";

  onFilterSelect(selected: string) {
    console.log(selected)


    this.modelChecked = false
    this.makeChecked = false
    this.typeChecked = false
    this.serialNumberChecked = false
    this.objectConditionChecked = false
    this.branchChecked = false
    this.departmentChecked = false
    this.groupChecked = false
    this.locationChecked = false
    this.objectByTemplateChecked = false
    this.selectedFilter = selected


    if (selected == "modelFilter") {
      this.modelChecked = true
    }

    if (selected == "makeFilter") {
      this.makeChecked = true
    }

    if (selected == "typeFilter") {
      this.typeChecked = true
    }

    if (selected == "serialNumberFilter") {
      this.serialNumberChecked = true
    }

    if (selected == "objectConditionFilter") {
      this.objectConditionChecked = true
    }

    if (selected == "branchFilter") {
      this.branchChecked = true
    }

    if (selected == "departmentFilter") {
      this.departmentChecked = true
    }

    if (selected == "objectByTemplateFilter") {
      this.objectByTemplateChecked = true
    }


    if (selected == "groupFilter") {
      this.groupChecked = true
    }

    if (selected == "locationFilter") {
      this.locationChecked = true
    }
  }

  applyFilter() {


    this.clearMapLayers()
    this.map.remove();

    if (this.modelChecked) {
      this.getAllModelByAndCid(this.model);
    }

    if (this.makeChecked) {
      this.getAllMakeByAndCid(this.make);
    }

    if (this.typeChecked) {
      this.getAllByType(this.typeFilter);
    }

    if (this.serialNumberChecked) {
      this.getAllBySerialNumberAndCid(this.serialNumberFilter);
    }

    if (this.objectConditionChecked) {
      this.getAllByObjectConditionAndCid(this.objectConditionFilter);
    }

    if (this.branchChecked) {
      this.getAllByBranchAndCid(this.branchFilter);
    }

    if (this.departmentChecked) {
      this.getAllByDepartmentAndCid(this.departmentFilter);
    }

    if (this.groupChecked) {
      this.getAllByGroup(this.groupFilter);
    }

    if (this.locationChecked) {
      this.getAllByLocationAndCid(this.locationFilter);
    }

    if (this.objectByTemplateChecked) {
      this.filterObjectByTemplate(this.objectByTemplateFilter);
    }

  }







  positiveCount = 0;
  negativeCount = 0;

  get totalVotes(): number {
    return this.positiveCount + this.negativeCount;
  }

  get positivePercentage(): number {
    return this.totalVotes === 0 ? 50 : Math.round((this.positiveCount / this.totalVotes) * 100);
  }

  get negativePercentage(): number {
    return 100 - this.positivePercentage;
  }

  vote(type: 'up' | 'down') {
    if (type === 'up') {
      this.positiveCount++;
    } else {
      this.negativeCount++;
    }
  }

  getAllMaintenanceScheduleByAssetId(objectInfoId: any) {
    this.generic_service.getAllMaintenanceScheduleByAssetId(objectInfoId).subscribe(
      (response: any) => {
        console.log(response);
        this.maintenanceScheduleList = response.response
      },
      (error: any) => {
        console.log(error)
      }
    )
  }

  getAllByLocationAndCid(location: any) {
    this.generic_service.getAllByLocationAndCid(location).subscribe(
      (res: any) => {
        console.log('Location Result:', res);
        if (res.response == null || res.response.length == 0 || res.response == undefined) {
          this.objectInfoList = []
          return

        }
        this.objectInfoList = res.response
        this.initMap();



        setTimeout(() => {
          if (this.map && this.objectInfoList.length > 0) {
            const latLngs = this.objectInfoList
              .filter((item: { lat: any; lng: any; }) => item.lat && item.lng)
              .map((item: { lat: any; lng: any; }) => [item.lat, item.lng]);

            if (latLngs.length > 0) {
              const bounds = L.latLngBounds(latLngs);
              this.map.fitBounds(bounds, { padding: [20, 20] }); // optional padding
              this.map.invalidateSize();
            }
          }
        }, 500);

      },
      (err: any) => {
        console.log('Serial Number Error:', err);
      }
    );
  }










  getMaintenanceType(type: any) {
    for (let list of this.maintenanceType) {
      if (list.value == type) {
        return list.key
      }
    }
    return ""
  }


  addTicketImageBtn() {
    document.getElementById("add-TicketImage-btn")?.click()
  }

  onTicketChange(event: any) {
    this.file = event.target.files[0];
    this.onTicketUpload()
  }

  onTicketUpload() {
    console.log(this.file);
    this.generic_service.uploadImage(this.file).subscribe((event: any) => {
      console.log(event);
      this.imagesList.push(event.response)
      let obj = {
        "image": event.response,
        "name": this.file.name,
        "type": this.file.type
      }
      this.imagesWithDetails.push(obj)
    });
  }

  selectLargeImage(largeImage: any) {
    this.largeImage = largeImage
  }



  addIconBtn() {
    document.getElementById("add-icon-btn")?.click()
  }

  onIconChange(event: any) {
    this.iconFile = event.target.files[0];
    this.onUploadIcon()
  }

  removeIcon() {
    this.icon = ""
  }

  onUploadIcon() {
    this.generic_service.uploadImage(this.iconFile).subscribe((event: any) => {
      console.log(event);
      this.icon = event.response
    });
  }


  selectConnection(event: any) {
    console.log(event.target.checked)
    if (event.target.value) {
      this.assetMonitoring = true
      this.assetMonitoringFrequency = 0
      this.assetMonitoringTimeSpan = 0
      this.connectionsList = []
      this.addConnection()
    } else {
      this.assetMonitoringFrequency = 0
      this.assetMonitoringTimeSpan = 0
      this.assetMonitoring = false
      this.connectionsList = []
    }
  }

  addConnection() {
    this.connectionsList.push({
      "key": "",
      "value": "",
    })
  }

  removeConnection(index: number) {
    this.connectionsList.splice(index, 1)
  }

  selectAssetHealth(event: any) {
    console.log(event.target.checked)
    if (event.target.value) {
      this.assetHealth = true
      this.assetHealthList = []
      this.addAssetHealth()
    } else {
      this.assetHealth = false
      this.assetHealthList = []
    }
  }

  addAssetHealth() {
    this.assetHealthList.push({
      "key": "",
      "value": "",
    })
  }

  removeAssetHealth(index: number) {
    this.assetHealthList.splice(index, 1)
  }



  filterInputByType(event: KeyboardEvent, inputType: 'number' | 'onlyText' | 'allText'): boolean {
    const key = event.key;
    const inputElement = event.target as HTMLInputElement;
    const currentValue = inputElement.value;

    // Always allow control keys (e.g., backspace, arrows, delete, tab, etc.)
    const controlKeys = [
      'Backspace', 'Delete', 'ArrowLeft', 'ArrowRight', 'ArrowUp', 'ArrowDown',
      'Tab', 'Home', 'End'
    ];
    if (controlKeys.includes(key)) {
      return true;
    }

    if (key === 'Enter') {
      return true;
    }

    switch (inputType) {
      case 'number':
        // Allow digits only
        if (!/^\d$/.test(key)) {
          event.preventDefault();
          return false;
        }
        break;

      case 'onlyText':
        // Allow letters and space (not as first character)
        if (!/^[a-zA-Z ]$/.test(key) || (key === ' ' && currentValue.length === 0)) {
          event.preventDefault();
          return false;
        }
        break;

      case 'allText':
        // Allow all characters, but disallow space as first character
        if (key === ' ' && currentValue.length === 0) {
          event.preventDefault();
          return false;
        }
        break;

      default:
        event.preventDefault();
        return false;
    }

    return true;
  }

  removeFile(fileInput: HTMLInputElement) {
    fileInput.value = '';
    this.file = ''
  }

  getObjectInfoByWildSearch() {
    console.log(this.searchFilter)
    if (this.searchFilter == "" || this.searchFilter == null) {
      return
    }
    this.generic_service.getObjectInfoByWildSearch(this.searchFilter).subscribe(
      (res: any) => {
        if (res.response == null || res.response.length == 0 || res.response == undefined) {
          this.objectInfoList = []
          return

        }
        this.objectInfoList = res.response
      },
      (err: any) => {
        console.log('Serial Number Error:', err);
      }
    );
  }


  isFullscreen = false;
  bi_fullscreen: any = "fullscreen-map"
  // bi-fullscreen-exit
  toggleFullscreen(): void {
    this.isFullscreen = !this.isFullscreen;

    // Optional: if using a map library like Leaflet or Google Maps,
    // call map.invalidateSize() or equivalent here
    setTimeout(() => {
      this.refreshMapSize();
    }, 300);

  }

  refreshMapSize() {
    setTimeout(() => {
      if (this.map) {
        this.map.invalidateSize();
        this.map.setView(this.map.getCenter(), this.map.getZoom());
      }
    }, 1000); // match this with your CSS transition timing
  }



  performance: any = false
  timeSpan: any = ""
  expectedOutput: any = ""
  uom: any = ""

  parentAssetId: any = 0
  isParentAssetId: any = false
  deployCurrentLocation: any = false
  alive: any = true


  selectPerformance(event: any) {
    console.log(event.target.checked)
    if (event.target.value) {
      this.performance = true
      this.timeSpan = ""
      this.expectedOutput = ""
      this.uom = ""
    } else {
      this.performance = false
      this.timeSpan = ""
      this.expectedOutput = ""
      this.uom = ""
    }
  }



  selectParentAsset(event: any) {
    console.log(event.target.checked)
    if (event.target.value) {
      this.isParentAssetId = true
      this.parentAssetId = 0
    } else {
      this.isParentAssetId = false
      this.parentAssetId = 0
    }
  }

  getAllUomMaster() {
    this.generic_service.getAllUomMaster().subscribe(
      (res: any) => {
        console.log(res)
        this.uomData = res.response
      }
    )
  }

  addProofBtn() {
    document.getElementById("add-proof-btn")?.click()
  }

  onProofChange(event: any) {
    this.file = event.target.files[0];

    // const validTypes = ['image/png', 'image/jpeg', 'image/jpg'];

    // if (!validTypes.includes(this.file.type)) {
    //   this.toastr.error('Only .png, .jpg, and .jpeg files are allowed.')
    //   return;
    // }
    this.onUploadProof()
  }


  onUploadProof() {
    console.log(this.file);
    this.generic_service.uploadImage(this.file).subscribe((event: any) => {
      console.log(event);
      for (let list of this.singleObjectTemplateData[0]?.warrantyInfo) {
        if (list.key == 'Proof Of Purchase (Scan and Upload Bill or invoice etc)') {
          list.value = event.response
        }
        this.proofFile = this.file.name
        this.proofFilePath = event.response
        const validTypes = ['image/png', 'image/jpeg', 'image/jpg'];

        if (validTypes.includes(this.file.type)) {
          this.proofFileType = this.file.type
        }
        console.log(this.proofFileType)
      }
      console.log(this.singleObjectTemplateData[0]?.warrantyInfo)
      // this.imagesList.push(event.response)
    });
  }




  async getParent(objectInfoId: number): Promise<void> {
    console.log("Fetching all parents for:", objectInfoId);

    const parentsObjects: any[] = [];
    const visitedIds: Set<number> = new Set();

    const fetchRecursive = async (id: number) => {
      if (visitedIds.has(id)) return;
      visitedIds.add(id);

      try {
        const response: any = await this.generic_service.getObjectInfoById(id).toPromise();
        const data = response?.response;

        if (!data || !data.lat || data.lat === 0) return;

        parentsObjects.push(data);

        if (Array.isArray(data.parentAssetId) && data.parentAssetId.length > 0) {
          for (const parentId of data.parentAssetId) {
            if (parentId && parentId !== 0) {
              await fetchRecursive(parentId);
            }
          }
        }

      } catch (error) {
        console.error(`Error fetching parent for ID ${id}:`, error);
      }
    };

    // Fetch all parent data
    await fetchRecursive(objectInfoId);
    console.log("All parents fetched:", parentsObjects);

    // Remove old lines if any
    if (this.parentLineLayer) {
      this.map.removeLayer(this.parentLineLayer);
    }

    // Draw connecting lines
    const features: any[] = [];
    for (const obj of parentsObjects) {
      if (Array.isArray(obj.parentAssetId)) {
        for (const pid of obj.parentAssetId) {
          const parentObj = parentsObjects.find(p => p.objectInfoId === pid);
          if (parentObj && obj.lat && obj.lng && parentObj.lat && parentObj.lng) {
            features.push({
              type: 'Feature',
              geometry: {
                type: 'LineString',
                coordinates: [
                  [obj.lng, obj.lat],
                  [parentObj.lng, parentObj.lat]
                ]
              }
            });
          }
        }
      }
    }

    this.parentLineLayer = L.geoJSON({
      type: 'FeatureCollection',
      features
    }, {
      style: { color: 'red', weight: 9, opacity: 1 }
    });

    this.parentLineLayer.addTo(this.map);

    // const decorator = (L as any).polylineDecorator( {
    //   patterns: [
    //     {
    //       offset: '5%',
    //       repeat: '10%',
    //       symbol: L.Symbol.arrowHead({
    //         pixelSize: 10,
    //         polygon: true,
    //         pathOptions: {
    //           stroke: true,
    //           color: 'blue',
    //           weight: 2
    //         }
    //       })
    //     }
    //   ]
    // }).addTo(this.map);

    // Adjust map bounds
    const latlngs = parentsObjects.map(o => [o.lat, o.lng]) as [number, number][];
    if (latlngs.length > 0) {
      this.map.fitBounds(latlngs);
    }
  }




}
